import AuditLogsIcon from '@material-ui/icons/List';
import BlockingIcon from '@material-ui/icons/Apps';
import CustomFieldsIcon from '@material-ui/icons/LibraryAdd';
import CustomMetricsIcon from '@material-ui/icons/Speed';
import DataProfileIcon from '@material-ui/icons/BarChart';
import ReportsIcon from '@material-ui/icons/MultilineChart';
// import HelpIcon from '@material-ui/icons/ContactSupportOutlined';
import FolderIcon from '@material-ui/icons/FolderOutlined';
import HomeIcon from '@material-ui/icons/HomeOutlined';
import IdentifierDomainsIcon from '@material-ui/icons/ReceiptOutlined';
import MatchingIcon from '@material-ui/icons/Link';
import SearchIcon from '@material-ui/icons/Search';
import SecurityIcon from '@material-ui/icons/LockOutlined';
import SettingsIcon from '@material-ui/icons/SettingsOutlined';
import EntitiesIcon from '@material-ui/icons/Widgets';
import StandardizationIcon from '@material-ui/icons/Language';

export default [
  {
    subheader: '',
    items: [
      {
        title: 'Home',
        href: '/presentation',
        icon: HomeIcon
      },
      {
        title: 'Search',
        href: '/search/attribs',
        permissions: ['RECORD_VIEW'],
        icon: SearchIcon
      },
      {
        title: 'User Files',
        href: '/user-files',
        permissions: ['FILE_IMPORT'],
        icon: FolderIcon
      },
      {
        title: 'Entities',
        href: '/entities',
        permissions: ['ENTITY_CONFIGURE'],
        icon: EntitiesIcon
      },
      {
        title: 'Identifier Domains',
        href: '/identifier-domains',
        permissions: ['IDENTIFIER_DOMAIN_VIEW'],
        icon: IdentifierDomainsIcon
      },
      {
        title: 'Custom Fields',
        href: '/custom-fields',
        permissions: ['CUSTOM_FIELDS_CONFIGURE'],
        icon: CustomFieldsIcon
      },
      {
        title: 'Blocking',
        href: '/blocking',
        permissions: ['BLOCKING_CONFIGURE'],
        icon: BlockingIcon
      },
      {
        title: 'Matching',
        href: '/matching',
        icon: MatchingIcon,
        items: [
          {
            title: 'Configuration',
            href: '/matching/basic',
            permissions: ['MATCHING_CONFIGURE']
          },
          {
            title: 'Review Probable Links',
            href: '/review-links',
            permissions: ['RECORD_LINKS_REVIEW']
          }
        ]
      },
      {
        title: 'Security',
        href: '/profile2',
        icon: SecurityIcon,
        items: [
          {
            title: 'Roles',
            href: '/roles',
            permissions: ['ROLE_VIEW']
          },
          {
            title: 'Users',
            href: '/users',
            permissions: ['USER_VIEW']
          }
        ]
      },
      {
        title: 'Custom Metrics',
        href: '/custom-metrics',
        permissions: ['MATCHING_CONFIGURE'],
        icon: CustomMetricsIcon
      },
      {
        title: 'Audit Logs',
        href: '/audit',
        permissions: ['RECORD_VIEW'],
        icon: AuditLogsIcon
      },
      {
        title: 'Data Profiles',
        href: '/data-profiles',
        permissions: ['DATA_PROFILE_VIEW'],
        icon: DataProfileIcon
      },
      {
        title: 'Standardization',
        href: '/standardizaton',
        icon: StandardizationIcon,
        items: [
          {
            title: 'Field Value Indexes',
            href: '/field-value-indexes',
            permissions: ['RECORD_EDIT']
          },
          {
            title: 'Facets',
            href: '/facets',
            permissions: ['RECORD_EDIT']
          },
          {
            title: 'Clustering',
            href: '/clustering',
            permissions: ['RECORD_EDIT']
          },
          {
            title: 'Operations',
            href: '/value-merge-operations',
            permissions: ['RECORD_EDIT']
          }
        ]
      },
      {
        title: 'Reports Manager',
        href: '/reports',
        permissions: ['REPORT_VIEW'],
        icon: ReportsIcon,
        items: [
          {
            title: 'Generate Reports',
            href: '/report-generation',
            permissions: ['REPORT_GENERATE']
          },
          {
            title: 'View Reports',
            href: '/report-viewing',
            permissions: ['REPORT_VIEW']
          }
        ]
      },
      {
        title: 'Administration',
        href: '/job-queue',
        icon: SettingsIcon,
        items: [
          {
            title: 'Job Queue',
            href: '/job-queue',
            permissions: ['JOB_QUEUE_VIEW']
          },
          {
            title: 'Operations',
            href: '/operations/globalIds'
          },
          {
            title: 'Settings',
            href: '/settings',
            permissions: ['GLOBAL_IDENTIFIERS_EDIT']
          },
          {
            title: 'Single Best Record',
            href: '/single-best-record',
            permissions: ['ENTITY_CONFIGURE']
          }
        ]
      }
      // ,
      // {
      //   title: 'Help',
      //   href: '/profile6',
      //   icon: HelpIcon
      // }
    ]
  }
];
